import { StateNode } from '@ansys-internal/awf-angular/store';
import { RequirementsSolved } from '../../../api';

export interface CompareJobsStateModel {
  jobs: any[] | null;
  resultsToCompare: RequirementsSolved[] | null;
}

export type CompareJobsInput =
  | { type: CompareJobsExecuteEnum.SET_JOBS; jobs: any[] | null }
  | {
      type: CompareJobsExecuteEnum.ADD_RESULT_TO_COMPARE;
      resultsToCompare: RequirementsSolved;
    }
  | {
      type: CompareJobsExecuteEnum.GET_RESULT_TO_COMPARE;
      resultId: string;
    }
  | {
      type: CompareJobsExecuteEnum.REMOVE_RESULT_FROM_COMPARE;
      resultId: string;
    }
  | { type: CompareJobsExecuteEnum.CLEAR_RESULTS_FROM_COMPARE };

export type CompareJobsOutput =
  | { type: CompareJobsExecuteEnum.SET_JOBS; jobs: any[] | null }
  | {
      type: CompareJobsExecuteEnum.ADD_RESULT_TO_COMPARE;
      resultsToCompare: RequirementsSolved;
    }
  | {
      type: CompareJobsExecuteEnum.GET_RESULT_TO_COMPARE;
      result: RequirementsSolved | undefined;
    }
  | {
      type: CompareJobsExecuteEnum.REMOVE_RESULT_FROM_COMPARE;
      resultsToCompare: RequirementsSolved[] | null;
    }
  | { type: CompareJobsExecuteEnum.CLEAR_RESULTS_FROM_COMPARE };

export type CompareJobsValueMap = {
  [CompareJobsExecuteEnum.SET_JOBS]: any[] | null;
  [CompareJobsExecuteEnum.ADD_RESULT_TO_COMPARE]: RequirementsSolved[] | null;
  [CompareJobsExecuteEnum.GET_RESULT_TO_COMPARE]: string; // pass id
  [CompareJobsExecuteEnum.REMOVE_RESULT_FROM_COMPARE]: string;
  [CompareJobsExecuteEnum.CLEAR_RESULTS_FROM_COMPARE]: null;
};

export enum CompareJobsExecuteEnum {
  SET_JOBS = 'SET_JOBS',
  ADD_RESULT_TO_COMPARE = 'ADD_RESULT_TO_COMPARE',
  GET_RESULT_TO_COMPARE = 'GET_RESULT_TO_COMPARE',
  REMOVE_RESULT_FROM_COMPARE = 'REMOVE_RESULT_FROM_COMPARE',
  CLEAR_RESULTS_FROM_COMPARE = 'CLEAR_RESULTS_FROM_COMPARE',
}

export class CompareJobsState implements StateNode<CompareJobsStateModel> {
  key: string = 'compare-jobs-state';
  defaultValue(): CompareJobsStateModel {
    return {
      jobs: null,
      resultsToCompare: null,
    };
  }
}
